import { Col, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import { ListGroupsQuery } from '@/core/domain/operational/Groups/Groups.types';

function GroupsExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListGroupsQuery>) {
  return (
    <Row gutter={[16, 16]}>
      <Col lg={4} span={24}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default GroupsExtraFilters;
